// Packages
import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import ReactMarkdown from "react-markdown"
import { GatsbyImage } from "gatsby-plugin-image"
import { getMediaQueries } from "@abmg-components"

// Images
import { graphql, useStaticQuery } from "gatsby"

// Styles
const { above } = getMediaQueries()
const Ad = styled.a`
  &.article-component {
    display: block;
    :hover,
    :active {
      text-decoration: none;
    }
  }
`
const PaddingContainer = styled.div`
  background: linear-gradient(227.53deg, #031d30 6.07%, #022946 97.24%);
  display: flex;
  height: 360px;
  margin-top: 32px;
  overflow: hidden;
  padding-left: 24px;
  padding-top: 24px;
  position: relative;
  .image {
    align-self: flex-end;
    margin-left: 13px;
    @media (min-width: 375px) {
      margin-left: -50px;
    }
    ${above.mobile`
      margin-left: 24px;
    `}
  }
  .logo {
    position: absolute;
    right: 24px;
    top: 0;
  }
  @media (min-width: 375px) {
    height: 296px;
  }
  ${above.mobile`
    height: 152px;
  `}
  ${above.mobile`
    padding-top: 16px;
  `}
`
const Content = styled.div`
  max-width: 207px;
  width: 100%;
  .button {
    background: #fff;
    color: var(--orca-grey-8-hex);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    margin: 0;
    margin-bottom: 30px;
    margin-right: 15px;
    padding: 5px 24px;
    width: 117px;
    ${above.mobile`
      margin-bottom: 22px;
    `}
  }
  .description * {
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 24px;
    margin-top: 8px;
    ${above.mobile`
      margin-bottom: 16px;
      margin-top: 0;
    `}
  }
  .title * {
    color: var(--pacific-blue-2-hex);
    font-family: Source Sans Pro, sans-serif;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    ${above.mobile`
      font-size: 22px;
      line-height: 28px;
    `}
  }
  @media (min-width: 375px) {
    flex-shrink: 0;
  }
  ${above.mobile`
    max-width: 260px;
  `}
`

// Main Component
export default function ArticleAd({ type }) {
  const data = useStaticQuery(graphql`
    query {
      ADT: contentfulArticleAd(type: { eq: "ADT" }) {
        title {
          childMarkdownRemark {
            rawMarkdownBody
          }
        }
        description {
          childMarkdownRemark {
            rawMarkdownBody
          }
        }
        link
        logo {
          gatsbyImageData(width: 480, quality: 90)
          resize {
            width
            height
          }
          file {
            url
          }
        }
        image {
          gatsbyImageData(width: 480, quality: 90)
          resize {
            width
            height
          }
          file {
            url
          }
        }
        buttonText
        type
      }
    }
  `)

  return (
    <>
      {type === "ADT" && (
        <Ad
          href={data.ADT.link}
          target="_blank"
          rel="noreferrer"
          className="article-component"
        >
          <PaddingContainer>
            {data.ADT.logo.gatsbyImageData && (
              <GatsbyImage
                image={data.ADT.childImageSharp.gatsbyImageData}
                width={data.ADT.logo.resize.width}
                height={data.ADT.logo.resize.height}
                className="logo"
              />
            )}
            {!data.ADT.gatsbyImageData && data.ADT.logo.file.url && (
              <img className="logo" src={data.ADT.logo.file.url} alt="ADT" />
            )}
            <Content>
              <ReactMarkdown className="title sans">{`### ${data.ADT.title.childMarkdownRemark.rawMarkdownBody}`}</ReactMarkdown>
              <ReactMarkdown className="description">
                {data.ADT.description.childMarkdownRemark.rawMarkdownBody}
              </ReactMarkdown>
              <p className="button">{data.ADT.buttonText}</p>
            </Content>
            {data.ADT.image.gatsbyImageData && (
              <GatsbyImage
                image={data.ADT.childImageSharp.gatsbyImageData}
                width={data.ADT.image.resize.width}
                height={data.ADT.image.resize.height}
                className="image"
              />
            )}
            {!data.ADT.image.gatsbyImageData && data.ADT.image.file.url && (
              <img className="image" src={data.ADT.image.file.url} alt="" />
            )}
          </PaddingContainer>
        </Ad>
      )}
    </>
  )
}

// Prop Types
ArticleAd.propTypes = {
  type: PropTypes.string.isRequired,
}
